module.exports = "<div style=\"display: block;\">\n  <span class=\"vertical_title\">\n    {{title}}\n  </span>\n  <canvas  baseChart id=\"poPendingChart\"\n    [datasets]=\"data\"\n    [title]=\"title\"\n    [labels]=\"labels\"\n    [options]=\"options\"\n    [legend]=\"barlineChartLegend\"\n    [colors]=\"colors\"\n    [chartType]=\"barChartType\">\n  </canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2648097449/src/src/app/common/po-chart/po-chart.component.html
// module id = ../../../../../src/app/common/po-chart/po-chart.component.html
// module chunks = main